import { ReactElement } from 'react'
import { SideNavigationProvider } from './components/sideNavigation/context'
import { AlertHandlerProvider } from './hooks/alertHandler'
import { AuthProvider } from './hooks/auth'
import { ExamsProvider } from './hooks/exams'
import { ContactProvider } from './hooks/faq'
import { LabsProvider } from './hooks/labs'
import { PatientsProvider } from './hooks/patients'
import { PlansProvider } from './hooks/plans'
import { ProcessExamProvider } from './hooks/processExam'
import { RequestNewLabProvider } from './hooks/requestNewLab'
import Routes from './Routes'

function App (): ReactElement {
  return (
    <AlertHandlerProvider>
      <AuthProvider>
        <ProcessExamProvider>
          <LabsProvider>
            <SideNavigationProvider>
              <PlansProvider>
                <PatientsProvider>
                  <ExamsProvider>
                    <RequestNewLabProvider>
                      <ContactProvider>
                        <Routes />
                      </ContactProvider>
                    </RequestNewLabProvider>
                  </ExamsProvider>
                </PatientsProvider>
              </PlansProvider>
            </SideNavigationProvider>
          </LabsProvider>
        </ProcessExamProvider>
      </AuthProvider>
    </AlertHandlerProvider>
  )
}

export default App
